module.exports = __webpack_public_path__ + "img/qr.9750afd3.svg";